import { combineReducers } from 'redux';
import { customCar } from "./customCar";


export default combineReducers({
    customCar
});



